var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTaxi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F1F2F2"
    },
    d: "M384.245,336.153c8.817,0,16.03,7.214,16.03,16.03s-7.214,16.03-16.03,16.03 c-8.817,0-16.03-7.214-16.03-16.03C368.215,343.367,375.428,336.153,384.245,336.153z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#768BA0"
    },
    d: "M384.245,304.091c26.531,0,48.092,21.562,48.092,48.092s-21.562,48.092-48.092,48.092 c-26.53,0-48.092-21.562-48.092-48.092C336.153,325.653,357.714,304.091,384.245,304.091z M400.275,352.183 c0-8.817-7.214-16.03-16.03-16.03c-8.817,0-16.03,7.214-16.03,16.03s7.214,16.03,16.03,16.03 C393.061,368.214,400.275,361,400.275,352.183z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#768BA0"
    },
    d: "M127.755,304.091c26.53,0,48.092,21.562,48.092,48.092s-21.562,48.092-48.092,48.092 s-48.092-21.562-48.092-48.092C79.663,325.653,101.224,304.091,127.755,304.091z M143.785,352.183c0-8.817-7.214-16.03-16.03-16.03 c-8.816,0-16.03,7.214-16.03,16.03s7.214,16.03,16.03,16.03C136.571,368.214,143.785,361,143.785,352.183z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F1F2F2"
    },
    d: "M127.755,336.153c8.817,0,16.03,7.214,16.03,16.03s-7.214,16.03-16.03,16.03 c-8.816,0-16.03-7.214-16.03-16.03C111.724,343.367,118.938,336.153,127.755,336.153z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A4B0C0"
    },
    points: "312.107,111.723 312.107,151.799 191.877,151.799 223.939,111.723 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE451"
    },
    d: "M504.475,288.061v64.122h-72.138c0-26.531-21.562-48.092-48.092-48.092 c-26.53,0-48.092,21.562-48.092,48.092H175.847c0-26.531-21.562-48.092-48.092-48.092s-48.092,21.562-48.092,48.092H7.525V207.907 h56.107l64.122-56.108h64.122h120.23h24.046l64.122,88.168c0,0,0,0,40.076,0C480.429,239.969,504.475,288.061,504.475,288.061z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.525,
    y: 207.911,
    style: {
      fill: "#FCB64F"
    },
    width: 56.108,
    height: 144.28
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#768BA0"
    },
    points: "223.939,111.723 191.877,151.799 239.969,151.799 272.031,111.723 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#31E8BB"
    },
    points: "312.107,183.861 360.199,247.983 239.969,247.983 231.954,239.969 231.954,183.861  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#31E8BB"
    },
    points: "199.893,183.861 199.893,247.983 103.709,247.983 103.709,231.953 143.785,199.891  143.785,183.861  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#31CCBB"
    },
    points: "264.015,183.861 231.954,183.861 231.954,239.969 239.969,247.983 272.031,247.983  264.015,239.969 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#231F20"
    },
    d: "M15.05,215.432h51.409l64.122-56.107H332.32l21.063,28.961l12.171-8.851l-25.57-35.16h-20.353 v-40.076h-99.31l-32.061,40.076h-63.335l-64.122,56.107H0v39.587h15.05V215.432z M227.555,119.249h77.027v25.026h-97.049 L227.555,119.249z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#231F20"
    },
    d: "M512,286.284l-0.795-1.589c-1.067-2.133-26.634-52.251-70.853-52.251h-36.245l-26.893-36.977 l-12.171,8.851l31.4,43.176h43.909c31.198,0,52.331,34.809,56.597,42.459v54.704h-57.611 c-3.686-27.119-26.981-48.092-55.094-48.092c-28.114,0-51.407,20.973-55.093,48.092h-81.167v15.05h81.167 c3.686,27.119,26.98,48.093,55.093,48.093c28.114,0,51.408-20.974,55.094-48.093H512V286.284z M384.245,392.75 c-22.368,0-40.567-18.199-40.567-40.568c0-22.368,18.199-40.567,40.567-40.567c22.369,0,40.568,18.199,40.568,40.567 C424.812,374.552,406.614,392.75,384.245,392.75z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#231F20"
    },
    d: "M127.754,296.566c-28.115,0-51.407,20.973-55.093,48.092H15.05v-80.643H0v95.693h72.661 c3.686,27.119,26.98,48.093,55.093,48.093s51.408-20.974,55.094-48.093h41.09v-15.05h-41.09 C179.162,317.539,155.868,296.566,127.754,296.566z M127.754,392.75c-22.368,0-40.567-18.199-40.567-40.568 c0-22.368,18.199-40.567,40.567-40.567c22.369,0,40.568,18.199,40.568,40.567C168.322,374.552,150.123,392.75,127.754,392.75z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#231F20"
    },
    d: "M127.754,328.628c-12.988,0-23.555,10.566-23.555,23.555c0,12.989,10.566,23.556,23.555,23.556 s23.556-10.567,23.556-23.556C151.31,339.194,140.742,328.628,127.754,328.628z M127.754,360.688c-4.69,0-8.505-3.816-8.505-8.506 c0-4.69,3.816-8.505,8.505-8.505c4.691,0,8.506,3.816,8.506,8.505C136.26,356.874,132.445,360.688,127.754,360.688z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#231F20"
    },
    d: "M384.245,328.628c-12.988,0-23.556,10.566-23.556,23.555c0,12.989,10.567,23.556,23.556,23.556 c12.989,0,23.556-10.567,23.556-23.556C407.801,339.194,397.233,328.628,384.245,328.628z M384.245,360.688 c-4.691,0-8.506-3.816-8.506-8.506c0-4.69,3.816-8.505,8.506-8.505c4.691,0,8.506,3.816,8.506,8.505 C392.75,356.874,388.936,360.688,384.245,360.688z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 31.571,
    y: 272.516,
    style: {
      fill: "#FFFFFF"
    },
    width: 16.031,
    height: 15.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.632,
    y: 272.516,
    style: {
      fill: "#231F20"
    },
    width: 16.031,
    height: 15.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 464.395,
    y: 296.566,
    style: {
      fill: "#FFFFFF"
    },
    width: 16.031,
    height: 15.05
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#231F20"
    },
    d: "M315.87,176.336h-91.441v66.749l12.423,12.423h138.397L315.87,176.336z M239.48,236.851v-45.465 h68.866l36.804,49.072H243.086L239.48,236.851z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#231F20"
    },
    d: "M207.418,176.336H136.26v19.939l-40.076,32.062v27.171h111.234V176.336z M192.368,240.458h-81.134 v-4.888l40.076-32.062v-12.122h41.058L192.368,240.458L192.368,240.458z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175.845,
    y: 272.516,
    style: {
      fill: "#231F20"
    },
    width: 16.031,
    height: 15.05
  })), /*#__PURE__*/React.createElement("rect", {
    x: 191.878,
    y: 288.549,
    style: {
      fill: "#FFFFFF"
    },
    width: 16.03,
    height: 15.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207.912,
    y: 272.516,
    style: {
      fill: "#231F20"
    },
    width: 16.031,
    height: 15.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.935,
    y: 288.549,
    style: {
      fill: "#FFFFFF"
    },
    width: 16.031,
    height: 15.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.968,
    y: 272.516,
    style: {
      fill: "#231F20"
    },
    width: 16.031,
    height: 15.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.001,
    y: 288.549,
    style: {
      fill: "#FFFFFF"
    },
    width: 16.031,
    height: 15.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.035,
    y: 272.516,
    style: {
      fill: "#231F20"
    },
    width: 16.03,
    height: 15.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.058,
    y: 288.549,
    style: {
      fill: "#FFFFFF"
    },
    width: 16.031,
    height: 15.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.091,
    y: 272.516,
    style: {
      fill: "#231F20"
    },
    width: 16.031,
    height: 15.05
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaxi);
export default __webpack_public_path__ + "static/media/taxi.4baf839c8df8f4e6d24875a34d27dbd5.svg";
export { ForwardRef as ReactComponent };